import moment from 'moment';
import { DISPLAY_DATE_FORMAT, DATE_FORMAT, MILLION } from '@/consts';

export default {
  lateDays: (state) => {
    try {
      const transactionDate = moment(state.contract.maturesDate, DISPLAY_DATE_FORMAT);
      const dueDate = moment(state.contract.oldDueDate, DATE_FORMAT);
      const days = transactionDate.diff(dueDate, 'days');
      return days >= 0 ? days : 0;
    } catch (error) {
      return 0;
    }
  },
  overdueFee: (state, getters) => {
    const interestAmountPerDay = (state.contract.oldInterestAmount * MILLION) / state.contract.oldProductRepayEvery;
    const penalty = interestAmountPerDay * getters.lateDays;
    return Math.round(penalty / 1000) / 1000;
  },
};
